export const getBase64 = (file, maxWidth = 2000, maxHeight = 2000) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      const img = new Image();
      img.onload = function () {
        // Create a canvas to resize the image
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // Calculate new width and height keeping the aspect ratio
        let width = img.width;
        let height = img.height;

        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width = width * ratio;
          height = height * ratio;
        }

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        // Convert the canvas to base64 (using 0.9 compression quality for better quality)
        const base64 = canvas.toDataURL("image/jpeg", 0.9); // Higher quality for better image resolution
        resolve(base64); // Returns the resized image in base64
      };
      img.onerror = reject;
      img.src = e.target.result; // Assigns the image to be loaded
    };
    reader.onerror = reject;
    reader.readAsDataURL(file); // Reads the file as base64
  });
};
